<template>
    <div class="task-center">
        <div class="task-center_tab">
            <div
                :class="['tab-item', { active: currentTab === tab.value }]"
                v-for="tab in tabList"
                :key="tab.value"
                @click="handleChangeTab(tab)"
            >
                {{ tab.label }}
            </div>
        </div>

        <div class="task-center_container">
            <div class="container-top">
                <div class="top-filter">
                    <div class="filter-item">
                        <div class="filter-item_label">需求名称：</div>
                        <el-input
                            v-model="filter.keyword"
                            placeholder="请输入需求标题"
                            size="small"
                            @change="getTaskList()"
                            clearable
                        ></el-input>
                    </div>

                    <div class="add-button primary-button" @click="handlePublish()" v-if="isPublish">发布需求</div>
                </div>

                <div class="top-filter status">
                    <div class="filter-item">
                        <div class="filter-item_label">需求状态：</div>

                        <div class="filter-item_check">
                            <div
                                :class="['check-item', { active: item.value === filter.status }]"
                                v-for="item in statusList"
                                :key="item.value"
                                @click="handleChangeFilter('status', item.value)"
                            >
                                {{ item.label }}
                            </div>
                        </div>
                    </div>
                </div>

                <div class="top-filter type">
                    <div class="filter-item" style="width: 100%">
                        <div class="filter-item_label">需求类型：</div>

                        <div :class="['filter-item_check', { collapse: typeCollapse.status && typeCollapse.value }]" ref="typeCheckListRef">
                            <div
                                :class="['check-item', { active: item.value === filter.type }]"
                                v-for="(item, index) in typeList"
                                :key="index"
                                @click="handleChangeFilter('type', item.value)"
                            >
                                {{ item.label }}
                            </div>
                        </div>

                        <div class="check-collapse" v-if="typeCollapse.status">
                            <div @click="typeCollapse.value = !typeCollapse.value">
                                <i class="el-icon-arrow-down" v-if="!typeCollapse.value"></i>
                                <i class="el-icon-arrow-up" v-else></i>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- 二级分类 -->
                <div class="top-filter type" v-if="filter.type !== 0">
                    <div class="filter-item" style="width: 100%">
                        <div class="filter-item_label">二级分类：</div>

                        <div :class="['filter-item_check']">
                            <div
                                :class="['check-item', { active: item.value === filter.secondType }]"
                                v-for="(item, index) in secondClassList"
                                :key="index"
                                @click="handleChangeFilter('secondType', item.value)"
                            >
                                {{ item.label }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="container-table">
                <el-table :data="tableData" style="width: 100%" :header-cell-style="{ background: '#f2f2f4' }" v-bind="tableAttr">
                    <el-table-column label="需求名称" show-overflow-tooltip>
                        <template slot-scope="scope">
                            <i :class="['task-mode', `task-mode-${scope.row.task_mode}`]">
                                {{ scope.row.task_mode === 1 ? "招募" : "竞单" }}
                            </i>
                            {{ scope.row.task_name }}
                        </template>
                    </el-table-column>

                    <el-table-column label="需求状态" show-overflow-tooltip>
                        <template slot-scope="scope">
                            <span style="color: #eda147" v-if="scope.row.task_status === 1">报名中</span>
                            <span style="color: #594fed" v-if="scope.row.task_status === 2">进行中</span>
                            <span v-if="scope.row.task_status === 3">圆满完成</span>
                        </template>
                    </el-table-column>

                    <el-table-column label="需求情况" show-overflow-tooltip>
                        <template slot-scope="scope">
                            {{
                                todoMap[scope.row.task_todos?.todo_key] ??
                                (ProcessLabelMap[scope.row.task_mode]?.[scope.row.task_progress] || "")
                            }}
                        </template>
                    </el-table-column>

                    <el-table-column label="提交时间" show-overflow-tooltip>
                        <template slot-scope="scope">{{ scope.row.update_time }}</template>
                    </el-table-column>

                    <el-table-column label="操作" width="200" :align="'center'">
                        <template slot-scope="scope">
                            <el-button type="text" style="color: #4659f2" @click="handleToDetail(scope.row.id)"> 查看详情 </el-button>

                            <template v-if="isPublish">
                                <el-button
                                    type="text"
                                    style="color: #4659f2"
                                    @click="handlePublish(scope.row.id)"
                                    v-if="scope.row.task_status !== 3"
                                >
                                    编辑
                                </el-button>
                                <el-button
                                    type="text"
                                    style="color: #f56c6c"
                                    @click="handleDelete(scope.row.id)"
                                    v-if="scope.row.deletable"
                                >
                                    删除
                                </el-button>
                            </template>
                        </template>
                    </el-table-column>
                </el-table>
            </div>

            <div class="container-pagination">
                <el-pagination
                    @current-change="handleCurrentChange"
                    :current-page.sync="pageParams.page"
                    :page-size="pageParams.pageSize"
                    layout="prev, pager, next, jumper"
                    :total="pageParams.total"
                >
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import taskApi from "../../../apis/task";
import { getRoleRouter, request, roleRouterMap, userTypeMap } from "./util";

export default {
    data() {
        return {
            role: Number(localStorage.getItem("role")),
            companyId: Number(localStorage.getItem("id")),
            classifyList: [], // 分类列表
            currentTab: 0,
            typeCollapse: {
                status: false,
                value: false,
            },
            tabList: [
                { label: "全部需求", value: 0 },
                { label: "招募", value: 1 },
                { label: "竞单", value: 2 },
            ],
            statusList: [
                { label: "全部", value: 0 },
                { label: "报名中", value: 1 },
                { label: "进行中", value: 2 },
                { label: "圆满完成", value: 3 },
            ],
            // 一级分类
            typeList: [{ label: "全部", value: 0 }],
            tableData: [], // 列表数据
            filter: {
                keyword: "",
                status: 0, // 0-全部，1-报名中, 2-进行中，3-圆满完成
                type: 0, // 0-全部
                secondType: 0, // 全部
            },
            pageParams: {
                page: 1,
                pageSize: 10,
                total: 0,
            },

            ProcessLabelMap: {
                1: {
                    1: "报名",
                    2: "需求方甄选",
                    3: "签订合同",
                    4: "接单方工作",
                    5: "验收交付成果",
                    6: "酬劳结算",
                    7: "评价",
                },
                2: {
                    1: "交稿",
                    2: "需求方甄选",
                    3: "中标公示",
                    4: "验收交付成果",
                    5: "酬劳结算",
                    6: "评价",
                },
            },

            todoMap: {
                0: "未报名", //学生取消报名后
                1: "待重新报名", //被设置为备选后
                2: "待签订合同", //需求方发起合同后
                3: "待交付成果", //接受合同后
                4: "待评价", //教师/企业验收通过
                5: "待重新交付成果", //成果被打回后
                6: "需求方甄选", //提交了报名
                7: "报名已淘汰", //被需求方淘汰
                8: "待发起合同", //需求方选中后
                9: "交付成果待审核", //交付成果后
                10: "已评价", //学生完成评价后
                11: "需求被下架", //已完成全部流程后 任务被删除
                12: "接单方工作", //学生确认合同后
                13: "验收交付成果", //学生提交成果后
                14: "酬劳结算", //验收通过后
                15: "中标公示", //竞单状态下选中学生
            },

            request: request(),
        };
    },

    props: {
        // 是否只能查自己的数据-超管可查全部
        isOwner: {
            type: Boolean,
            default: true,
        },

        // 是否可以发布需求-超管不可
        isPublish: {
            type: Boolean,
            default: true,
        },

        // 表格attr
        tableAttr: {
            type: Object,
            default: () => {},
        },
    },

    watch: {
        "filter.type"(val) {
            if (val === 0) {
                this.filter.secondType = 0;
            }
        },
    },

    computed: {
        filterParams() {
            const params = {};

            if (this.currentTab !== 0) params.filter_mode = this.currentTab;
            if (this.filter.status !== 0) params.filter_status = this.filter.status;
            if (this.filter.keyword) params.filter_name = this.filter.keyword;

            if (this.filter.type !== 0) {
                params.filter_type =
                    this.filter.secondType === 0 ? this.secondClassList.map((item) => item.value) : [this.filter.secondType];
            }

            return params;
        },

        // 二级分类列表
        secondClassList() {
            if (this.filter.type === 0) return [];

            const list = [{ label: "全部", value: 0 }];

            const classList = this.classifyList.find((item) => item.id === this.filter.type)?.subClassification || [];
            list.push(...classList.map((item) => ({ label: item.name, value: item.id })));

            return list;
        },
    },

    created() {
        this.getClassList();

        this.getTaskList();
    },

    methods: {
        // 获取分类
        getClassList(index) {
            let params = {
                paging: 0,
                class_type: 2,
            };

            this.request.axiosGetBy(this.$api.classification, params, (res) => {
                if (res.code == 200) {
                    // const classList = (res.data?.data || []).flatMap((item) => item.subClassification);
                    // this.typeList.push(...classList.map((item) => ({ label: item.name, value: item.id })));
                    this.classifyList = res.data?.data?.filter((item) => item.subClassification?.length > 0) || [];
                    this.typeList.push(...this.classifyList.map((item) => ({ label: item.name, value: item.id })));

                    this.$nextTick(() => {
                        this.initTypeCollapse();
                    });
                }
            });
        },

        // 初始化类型选择collapse
        initTypeCollapse() {
            const el = this.$refs.typeCheckListRef;

            if (el) {
                if (el.scrollHeight > el.clientHeight) {
                    this.typeCollapse.status = true;
                }
            }
        },

        // 获取任务列表数据
        getTaskList() {
            let params = {
                page: this.pageParams.page,
                page_size: this.pageParams.pageSize,
                user_type: userTypeMap[this.role] ?? null,
                is_owner: this.isOwner,
                ...this.filterParams,
            };

            this.request.axiosPost(taskApi.taskList, params, (res) => {
                if (res.code === 200) {
                    this.tableData = res.data?.list || [];
                    this.pageParams.total = res.data?.total;
                } else {
                    this.$message.error(res.message);
                }
            });
        },

        handleChangeFilter(key, val) {
            if (this.filter?.[key] === val) return;

            this.filter[key] = val;
            if (key === "type") this.filter.secondType = 0; // 点击一级分类，二级重置0

            this.getTaskList();
        },

        handleChangeTab(tab) {
            if (this.currentTab === tab.value) return;

            this.currentTab = tab.value;
            this.pageParams.page = 1;
            this.getTaskList();
        },

        handleCurrentChange(val) {
            this.pageParams.page = val;

            this.getTaskList();
        },

        // 发布需求
        handlePublish(id) {
            const toPath = getRoleRouter("edit");
            if (toPath) {
                const query = id ? { id: id } : {};

                this.$router.push({
                    path: toPath,
                    query: query,
                });
            }
        },

        // 查看详情
        handleToDetail(id) {
            const toPath = getRoleRouter("detail");

            if (toPath) {
                const url = this.$router.resolve({
                    path: toPath,
                    query: { id: id },
                }).href;

                window.open(url, "_blank");
            }
        },

        // 删除需求
        handleDelete(id) {
            this.$confirm("是否删除该需求？删除后将无法恢复", "删除提示", {
                cancelButtonText: "取消",
                confirmButtonText: "确定",
                type: "warning",
                customClass: "ek-confirm warning",
            }).then(() => {
                const params = { id: id };

                this.request.axiosPost(taskApi.deleteTask, params, (res) => {
                    if (res.code === 200) {
                        this.$message.success(res.message);
                        this.getTaskList();
                    } else {
                        this.$message.error(res.message);
                    }
                });
            });
        },
    },

    mounted() {},
};
</script>

<style lang="scss" scoped>
.task-center {
    width: 100%;
    min-height: calc(100vh - 110px);
    // border: 1px solid black;
    display: flex;
    flex-direction: column;

    & > * {
        flex-shrink: 0;
    }

    &_tab {
        height: 52px;
        display: flex;
        // gap: 8px;

        .tab-item {
            min-width: 104px;
            display: flex;
            justify-content: center;
            align-items: center;
            // padding-inline: 20px;
            font-family: PingFang SC, PingFang SC;
            font-weight: 500;
            font-size: 14px;
            color: #37383b;
            cursor: pointer;

            &.active {
                color: #685df5;
                background-color: #ffffff;
                border-radius: 4px 4px 0px 0px;
            }
        }
    }

    &_container {
        flex: 1;
        background-color: #ffffff;
        position: relative;

        .container-top {
            padding-top: 33px;
            padding-inline: 40px;

            .top-filter {
                & + .top-filter {
                    margin-top: 4px;
                }

                &.status,
                &.type {
                    justify-content: flex-start;

                    .filter-item {
                        align-items: flex-start;
                    }
                }

                display: flex;
                align-items: center;
                justify-content: flex-end;
                gap: 16px;

                .filter-item {
                    display: flex;
                    align-items: center;
                    position: relative;

                    &_label {
                        flex-shrink: 0;
                        font-weight: 500;
                        font-size: 14px;
                        color: #6e7277;
                        line-height: 30px;
                    }

                    &_check {
                        --height: 28px;
                        display: flex;
                        align-items: flex-start;
                        flex-wrap: wrap;
                        gap: 4px;
                        // width: calc(100% - 85px);
                        height: var(--height);
                        overflow: hidden;

                        &.collapse {
                            height: fit-content;
                        }

                        .check-item {
                            font-family: PingFang SC, PingFang SC;
                            font-weight: 400;
                            font-size: 14px;
                            color: #666666;
                            padding: 4px 8px;
                            cursor: pointer;
                            flex-shrink: 0;

                            &.active {
                                background: #edecff;
                                border-radius: 4px;
                                color: #594fed;
                            }
                        }
                    }

                    .check-collapse {
                        position: absolute;
                        right: 0;
                        top: 0;
                        height: 28px;
                        display: flex;
                        align-items: center;
                        cursor: pointer;
                    }
                }

                .primary-button {
                    width: 88px;
                    height: 32px;
                    background: #594fed;
                    border-radius: 20px;
                    font-family: PingFang SC, PingFang SC;
                    font-weight: 500;
                    font-size: 14px;
                    color: #ffffff;
                    line-height: 30px;
                    text-align: center;
                    cursor: pointer;
                }
            }
        }

        .container-table {
            margin-top: 16px;
            padding-inline: 40px;
            padding-bottom: 70px;

            .task-mode {
                display: inline-block;
                width: 36px;
                height: 21px;
                border-radius: 2px;
                font-weight: 600;
                font-size: 12px;
                font-style: normal;
                text-align: center;
                flex-shrink: 0;
                margin-right: 4px;

                &-1 {
                    background: #f6ffed;
                    border: 1px solid #01a04b;
                    color: #6bc45c;
                }

                &-2 {
                    background: #fff4dd;
                    border: 1px solid #e49906;
                    color: #e49906;
                }
            }

            // .task-name {
            //     display: flex;
            //     align-items: center;
            //     gap: 4px;
            //     width: fit-content;
            // }
        }

        .container-pagination {
            position: absolute;
            bottom: 0;
            left: 0;
            width: 100%;
            height: 52px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-top: 1px solid #eff1f7;
        }
    }
}
</style>
